const BLOCKED_TAGS = new Set(['script', 'iframe', 'object', 'embed', 'link', 'style'])
const EVENT_HANDLER_REGEX = /^on/i
const CONTROL_CHARACTER_RANGE = '\\u0000-\\u001F\\u007F'
const CONTROL_CHARACTERS_REGEX = new RegExp(`[${CONTROL_CHARACTER_RANGE}]`, 'g')

const sanitizeAttributeValue = (value) =>
  String(value)
    .replace(/javascript:/gi, '')
    .replace(/data:text\/html/gi, '')
    .replace(CONTROL_CHARACTERS_REGEX, '')

const stripDisallowedAttributes = (tagName, attributes, allowedAttributes = {}) => {
  if (!attributes) {
    return ''
  }

  const safeAttributes = []
  const allowed = new Set([...(allowedAttributes['*'] ?? []), ...(allowedAttributes[tagName] ?? [])])

  attributes
    .trim()
    .split(/\s+/)
    .forEach((attribute) => {
      const [rawName, ...rawValueParts] = attribute.split('=')
      if (!rawName) {
        return
      }
      const name = rawName.trim()
      if (EVENT_HANDLER_REGEX.test(name) || !allowed.has(name)) {
        return
      }
      const rawValue = rawValueParts.join('=')
      if (!rawValue) {
        safeAttributes.push(name)
        return
      }
      const cleanedValue = sanitizeAttributeValue(rawValue.replace(/^"|"$/g, ''))
      safeAttributes.push(`${name}="${cleanedValue}"`)
    })

  return safeAttributes.length > 0 ? ` ${safeAttributes.join(' ')}` : ''
}

const BASIC_SANITIZE_OPTIONS = {
  ALLOWED_TAGS: [],
  ALLOWED_ATTR: {},
}

const sanitizeHtmlMarkup = (input, options = {}) => {
  const { ALLOWED_TAGS: allowedTags = BASIC_SANITIZE_OPTIONS.ALLOWED_TAGS, ALLOWED_ATTR: allowedAttributes = BASIC_SANITIZE_OPTIONS.ALLOWED_ATTR } = options

  const allowedTagSet = new Set(allowedTags)
  const sanitized = String(input ?? '')
    .replace(/<!DOCTYPE[^>]*>/gi, '')
    .replace(/<!--([\s\S]*?)-->/g, '')
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
    .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, '')
    .replace(/<\/?\s*([a-z0-9-]+)([^>]*)>/gi, (match, tagName, attributes) => {
      const normalizedTag = tagName.toLowerCase()
      if (BLOCKED_TAGS.has(normalizedTag)) {
        return ''
      }
      if (!allowedTagSet.has(normalizedTag)) {
        return ''
      }
      const safeAttributes = stripDisallowedAttributes(normalizedTag, attributes, allowedAttributes)
      return `<${match.startsWith('</') ? '/' : ''}${normalizedTag}${safeAttributes}>`
    })

  return sanitized
}

export const DOMPurify = {
  sanitize(value, options = BASIC_SANITIZE_OPTIONS) {
    const sanitizedMarkup = sanitizeHtmlMarkup(value, options)
    return sanitizedMarkup.replace(/[<>]/g, (character) => ({ '<': '&lt;', '>': '&gt;' }[character]))
  },
}

const dompurify = {
  sanitize(value, options) {
    return DOMPurify.sanitize(value, options)
  },
}

dompurify.default = dompurify

dompurify.version = 'local-1.0.0'

dompurify.removed = []

dompurify.setConfig = () => {}

dompurify.addHook = () => {}

dompurify.removeHook = () => {}

dompurify.isSupported = () => true

export default dompurify
